/*  PROPS CONTROLLER:

    - show
    - title
    - text
    - showInput
    - inputLabel
    - showButtons
    - confirmFunction
    - confirmButtonText
    - cancelFunction
    - cancelButtonText
    - onClose
*/

import { useContext, useEffect } from 'react';
import styles from './css/boxAlert.module.css';
import { IoMdCloseCircle } from 'react-icons/io';
import CompanyContext from '../../contexts/companyContext';



export default function BoxAlert({show, showCloseButton, onClose, title, text, input, inputLabel, showButtons, confirmButtonText, confirmFunction, cancelButtonText, cancelFunction, body}) {
    const { companyData } = useContext(CompanyContext);
    

    if(show == true) return (
        <div className={styles.alertComponent}>
            <div className={styles.overlayCart}></div>

            <div className={styles.alertBox}>
                {showCloseButton ? (
                    <button className={styles.closeDataRequest} onClick={() => onClose()}>
                        <IoMdCloseCircle size={25} color="#333" />
                    </button>
                ) : null}

                <h1 className={styles.titleAlertBox} style={{ marginBottom: 0 }}>
                    {title}
                </h1>


                {body ? (
                    <div style={{width: '100%', paddingRight: 10, paddingLeft: 10}}>
                        {body}
                    </div>

                ) : (
                    <>
                        {text && <p className={styles.textAlertBox} style={{paddingBottom: input ? 0 : 60}}>{text}</p>}

                        {input && (
                            <div className={styles.inputRequestArea}>
                                {inputLabel && <p className={styles.labelRequestData}>{inputLabel}</p>}
                                {input}
                            </div>
                        )}

                        {!showButtons ? (
                            <button className={styles.proceedRequestDataBtn} style={{ backgroundColor: companyData.background_color }} onClick={() => confirmFunction ? confirmFunction() : onClose()}>
                                <p className={styles.textAlertButton} style={{ color: companyData.text_color }}>
                                    {confirmButtonText || 'Ok'}
                                </p>
                            </button>

                        ) : (
                            <div className={styles.buttonsBoxArea}>
                                <button className={styles.buttonBoxConfig} id={styles.leftBoxButton} style={{ backgroundColor: companyData.background_color, borderColor: companyData.text_color }} onClick={() => cancelFunction()}>
                                    <p className={styles.textAlertButton} style={{ color: companyData.text_color }}>
                                        {cancelButtonText || 'Voltar'}
                                    </p>
                                </button>
                                <button className={styles.buttonBoxConfig} id={styles.rightBoxButton} style={{ backgroundColor: companyData.background_color, borderColor: companyData.text_color }} onClick={() => confirmFunction()}>
                                    <p className={styles.textAlertButton} style={{ color: companyData.text_color }}>
                                        {confirmButtonText || 'Prosseguir'}
                                    </p>
                                </button>
                            </div>
                        )}
                    </>
                )}

            </div>
        </div>
    );
}
